import globalEnum from "../enums/globalEnum";
import { OrderFormState } from "../types/types";
import PaymentMethods = globalEnum.PaymentMethods;
import orderStatus = globalEnum.orderStatus;

export const initialFormState: OrderFormState = {
	isMulti: false,
	orderServices: [],
	transportation: 200000,
	finalPrice: 0,
	price: 0,
	discountAmount: 0,
	serviceId: null,
	date: "",
	time: "8",
	toTime: "8",
	shouldUseWallet: false,
	isUrgent: false,
	status: orderStatus.AwaitingPayment,
	shouldSendWorkerSMS: false,
	taxAmount: 0,
	address: {
		id: null,
		title: "",
		phoneNumber: "",
		description: "",
		vahed: "",
		pelak: "",
	},
	user: {
		id: "",
		name: "",
		lastName: "",
		phoneNumber: "",
		nationalCode: "",
		isVerified: false,
		addresses: [],
	},
	payment: {
		method: PaymentMethods.card,
		finalPrice: 0,
		shouldUseWallet: false,
		isPaid: false,
	},
};
